module.exports = __webpack_public_path__ + "img/2.3c0271d1.png";